<template>
  <!-- :navigate-to="[startingSlide || 0, false]" -->
  <carousel
    :per-page="1"
    :perPageCustom="[[500, 2],[768, 3], [1024, 4], [1200, 5]]"
    :scrollPerPage="false"
    :mouse-drag="false"
    :paginationEnabled="false"
    :navigationEnabled="true"
    :autoplay="shouldAutoplay"
    :autoplayTimeout="4000"
    :autoplayHoverPause="true"
    navigationNextLabel=">"
    navigationPrevLabel="<"
    :loop="false"
    @navigation-click="navigationClick"
  >
    <slot></slot>
  </carousel>
</template>

<script>
// Documentation https://github.com/SSENSE/vue-carousel
import { Carousel } from "vue-carousel";

export default {
  components: {
    Carousel,
    // Slide
  },
  props: [
    // "startingSlide",
    "autoplay",
  ],
  data() {
    return {
      interactedWith: false,
      interactionTimeout: null
    };
  },
  methods: {
    navigationClick() {
      //called when navigation clicked
      this.interactedWith = true;
      clearTimeout(this.interactionTimeout);
      //re-enable autoplay with delay after last interaction
      this.interactionTimeout = setTimeout(() => {
        this.interactedWith = false;
      }, 5000);
    }
  },
  computed: {
    shouldAutoplay() {
      let defaultAutoplay = this.autoplay === undefined ? true : this.autoplay;
      return defaultAutoplay && !this.interactedWith;
    }
  }
};
</script>


<style lang="scss" scoped>

.VueCarousel{
  width: calc(100% - 2*32px);
  margin: 15px auto;
}

.VueCarousel::v-deep .VueCarousel-slide{
  padding: 0 5px;
}

.VueCarousel::v-deep .VueCarousel-navigation {
  .VueCarousel-navigation-button{
    background: darken($CTgrey, 20%);
    font-weight:bold;
    font-size:1.2em;
    outline: none;
    color:white;
    &:hover:not(.VueCarousel-navigation--disabled){
      background: darken($CTgrey, 40%);
    }
  }
  .VueCarousel-navigation-prev{
    left:-5px; //same as border width
    border-radius: 3px 0 0 3px;

  }
  .VueCarousel-navigation-next{
    right: -5px;
    border-radius: 0 3px 3px 0;
  }
}
</style>